export default __webpack_public_path__ + "static/media/notification-warning.b6a98f22.svg";